import { render } from "./EmojiSelect.vue?vue&type=template&id=64e76206&scoped=true"
import script from "./EmojiSelect.vue?vue&type=script&lang=js"
export * from "./EmojiSelect.vue?vue&type=script&lang=js"

import "./EmojiSelect.vue?vue&type=style&index=0&id=64e76206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e76206"]])

export default __exports__